"use strict";

var _Icon;
import { MenuHamburgerIcon } from '@autoguru/icons';
import { Box, Icon } from '@autoguru/overdrive';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const windowAsideToggleFnName = '__open_ag__sidenav';
const AppSideHandle = () => {
  const openAside = useCallback(() => {
    if (typeof window[windowAsideToggleFnName] === 'function') window[windowAsideToggleFnName]();
  }, []);
  return /*#__PURE__*/_jsx(Box, {
    as: "button"
    // biome-ignore lint/a11y/useSemanticElements: migration quick fix. To be fixed when code is touched
    ,
    role: "button",
    "aria-label": "Aside menu button",
    display: "flex",
    onClick: openAside,
    children: _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
      size: "large",
      icon: MenuHamburgerIcon
    }))
  });
};
export default AppSideHandle;